import type { BridgeMcpToolDefinition } from '../../../bridge-mcp-tool-types.js';
import { GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL, LIST_PARENT_SESSION_PROMPTS_TOOL } from './tool-names.js';

const SESSION_ID_SCHEMA = {
  type: 'string',
  description:
    'Id of this forked (child) session — not the parent session id. Required on every tool call.',
};

export const FORK_SESSION_MCP_TOOL_DEFINITIONS: BridgeMcpToolDefinition[] = [
  {
    name: LIST_PARENT_SESSION_PROMPTS_TOOL,
    description:
      'List user prompts (main turns) from the parent session a fork was created from. Requires sessionId. Returns an error if the session has no parent history (not a fork).',
    inputSchema: {
      type: 'object',
      properties: { sessionId: SESSION_ID_SCHEMA },
      required: ['sessionId'],
      additionalProperties: false,
    },
  },
  {
    name: GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL,
    description:
      'Full transcript for one parent-session turn, including tool calls and agent messages. Requires sessionId and turnId. Returns an error if the session has no parent history (not a fork).',
    inputSchema: {
      type: 'object',
      properties: {
        sessionId: SESSION_ID_SCHEMA,
        turnId: { type: 'string', description: 'Turn id from list_parent_session_prompts' },
      },
      required: ['sessionId', 'turnId'],
      additionalProperties: false,
    },
  },
];
